
import React from 'react';

const ScrollIndicator = () => {
  return (
    <div className="absolute bottom-4 md:bottom-8 left-1/2 transform -translate-x-1/2">
      <div className="w-5 h-8 md:w-6 md:h-10 border-2 border-gray-400/50 rounded-full flex justify-center">
        <div className="w-1 h-2 md:h-3 bg-gray-400 rounded-full mt-1 md:mt-2 animate-bounce" />
      </div>
    </div>
  );
};

export default ScrollIndicator;
